import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Anchor, CheckCircle2, Download, Eye, Loader2 } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import { ouvrirPdf } from '../reglement-interieur/SignerReglementDialog';

const BTN = 'inline-flex items-center gap-1.5 rounded-lg bg-white px-3 py-1.5 text-xs font-semibold ring-1 transition-colors';
const voir = (mode) => ouvrirPdf('/livret-base/pdf', 'Carnet_integration_FISL.pdf', mode);

const Engagement = ({ onEngage, tuteur }) => {
  const [lu, setLu] = useState(false);
  const [envoi, setEnvoi] = useState(false);
  const valider = async () => {
    setEnvoi(true);
    try { await axios.post('/livret-base/engagement'); toast.success('Engagement enregistré'); onEngage(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Enregistrement impossible'); }
    finally { setEnvoi(false); }
  };
  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 rounded-lg bg-white/80 p-3">
      <label className="flex flex-1 items-start gap-2 text-sm">
        <Checkbox checked={lu} onCheckedChange={(v) => setLu(!!v)} className="mt-0.5" data-testid="livret-base-case-lu" />
        {tuteur ? "J'ai pris connaissance du carnet d'intégration et je m'engage, en tant que tuteur, à suivre et accompagner mon stagiaire comme prévu au chapitre 11." : "J'ai lu le carnet d'intégration et je m'engage à respecter ces règles sur la base et en entreprise de stage."}
      </label>
      <button type="button" disabled={!lu || envoi} onClick={valider} data-testid="livret-base-engager"
        className="inline-flex items-center gap-1.5 rounded-lg bg-[#0F172A] px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-40">
        {envoi && <Loader2 className="h-3.5 w-3.5 animate-spin" />} Je m'engage
      </button>
    </div>
  );
};

// Stagiaire (avec engagement daté), tuteur et formateur (consultation)
export const TuileLivretBase = ({ user }) => {
  const [etat, setEtat] = useState(null);
  const charger = () => axios.get('/livret-base/engagement/moi').then(({ data }) => setEtat(data)).catch(() => {});
  useEffect(() => { charger(); }, []);
  if (!etat?.publie) return null;
  const stagiaire = ['stagiaire', 'tuteur'].includes(user?.role);
  const tuteur = user?.role === 'tuteur';
  const engage = etat.engage_le;
  const ton = stagiaire && !engage ? 'border-amber-300 bg-amber-50 text-amber-900' : 'border-lime-300 bg-lime-50 text-slate-900';
  return (
    <div className={`rounded-xl border p-4 ${ton}`} data-testid="livret-base-tuile">
      <div className="flex flex-wrap items-center gap-4">
        <div className="rounded-lg bg-white/70 p-2"><Anchor className="h-5 w-5" /></div>
        <div className="min-w-[200px] flex-1">
          <p className="font-semibold">Carnet d'intégration</p>
          <p className="text-xs opacity-80" data-testid="livret-base-statut">
            {stagiaire ? (engage ? `Engagement validé le ${new Date(engage).toLocaleDateString('fr-FR')}` : tuteur ? 'À lire et à valider : note au tuteur et engagement (chapitre 11)' : 'À lire et à valider avant vos séances sur la base')
              : 'Règles de vie des stagiaires sur la base de pratique et en entreprise de stage'}
          </p>
        </div>
        <div className="flex gap-2">
          <button type="button" onClick={() => voir()} className={`${BTN} ring-slate-200 hover:bg-slate-100`} data-testid="livret-base-consulter"><Eye className="h-3.5 w-3.5" /> Consulter</button>
          <button type="button" onClick={() => voir('download')} className={`${BTN} ring-slate-200 hover:bg-slate-100`} data-testid="livret-base-telecharger"><Download className="h-3.5 w-3.5" /> Télécharger</button>
          {stagiaire && engage && <CheckCircle2 className="h-6 w-6 text-emerald-600" />}
        </div>
      </div>
      {stagiaire && !engage && <Engagement onEngage={charger} tuteur={tuteur} />}
    </div>
  );
};
